module.exports = __webpack_public_path__ + "static/media/Giuseppe_Toniolo.c638d117.jpg";